<div class="grid w-screen overflow-y-hidden lg:grid-cols-2">
  <div class="hidden h-dvh overflow-clip lg:block drop-shadow-sm">
    <div class="absolute inset-0 flex items-center justify-center">
      <div
        class="relative z-10 flex flex-col items-center justify-center w-full gap-8 p-8"
      >
        <div
          class="flex items-center justify-center w-full duration-700 animate-in fade-in"
        >
          <div
            class="flex items-center justify-center w-full duration-1000 animate-in zoom-in"
          >
            <img
              src="assets/illustrations/biometric-security.svg"
              alt="logo"
              class="w-full md:~w-[28rem]/[46rem]"
            />
          </div>
        </div>
        <div class="text-center text-white">
          <div class="duration-300 animate-in fade-in">
            <div
              class="duration-700 delay-200 animate-in slide-in-from-left-10"
            >
              <h2 class="mb-4 text-3xl font-bold fade-in">
                Welcome to L&D Support
              </h2>
            </div>
          </div>
          <div class="duration-300 animate-in fade-in">
            <div
              class="duration-700 delay-300 animate-in slide-in-from-right-10"
            >
              <p class="text-xl fade-in">
                Your trusted partner in human growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div #notificationContainer class="relative w-full">
    <div
      class="relative flex flex-row items-center justify-center p-4 my-auto overflow-hidden h-dvh"
    >
      <div class="fixed w-full h-dvh loginComponent overflow-clip"></div>
      <div
        class="relative z-10 grid grid-flow-row gap-6 mx-auto w-90vw md:~w-[28rem]/[40rem]"
      >
        <div
          class="flex flex-col gap-2 duration-500 ease-in-out transition-width animate-in fade-in zoom-in"
        >
          <div
            class="relative grid grid-flow-row gap-6 p-4 bg-white border-2 border-gray-100 shadow-md rounded-2xl md:p-8 drop-shadow-lg"
          >
            <ldm-logo class="flex w-full"></ldm-logo>

            <router-outlet></router-outlet>

            <hr class="mt-2 border-t border-gray-200" />

            <!-- Footer section -->
            <div
              class="flex flex-col gap-3 mt-4 text-xs md:text-sm md:grid md:grid-cols-3 md:gap-8 md:mt-6"
            >
              <!-- Legal links -->
              <div
                class="flex justify-center gap-4 order-2 md:order-none md:flex-col md:gap-1.5 md:justify-start"
              >
                <p
                  class="text-gray-500 transition-colors cursor-pointer hover:text-primary"
                  [innerHTML]="'PrivacyStatement' | translate"
                ></p>
                <p
                  class="text-gray-500 transition-colors cursor-pointer hover:text-primary"
                  [innerHTML]="'LegalDocs' | translate"
                ></p>
              </div>

              <!-- Contact and Language selector container for mobile -->
              <div class="flex items-start justify-between order-1 md:contents">
                <!-- Contact info -->
                <div
                  class="flex flex-col gap-0.5 md:items-center md:col-span-1"
                >
                  <p
                    class="font-medium text-gray-700"
                    [innerHTML]="'ContactOptions.Header' | translate"
                  ></p>
                  <a
                    [href]="'mailto:' + ('ContactOptions.Email' | translate)"
                    class="transition-colors text-primary hover:text-primary-dark"
                    >{{ "ContactOptions.Email" | translate }}</a
                  >
                  <a
                    [href]="'tel:' + ('ContactOptions.Phone' | translate)"
                    class="transition-colors text-primary hover:text-primary-dark"
                    >{{ "ContactOptions.Phone" | translate }}</a
                  >
                </div>

                <!-- Language selector -->
                <div class="md:col-span-1 md:flex md:justify-end">
                  <ldm-language-dropdown-selector></ldm-language-dropdown-selector>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
